import { type RouteObject } from 'react-router';

import { ApplicationRoutesEnum } from 'src/pages/Application/routes.enum';

export const applicationRoutes: RouteObject = {
  path: 'applications/:appId',
  lazy: async () => {
    const { default: Component } = await import('src/pages/Application/View');

    return { Component };
  },
};

export const applicationSetupRoutes: RouteObject = {
  path: `applications/:appId/${ApplicationRoutesEnum.Setup}`,
  lazy: async () => {
    const { default: Component } = await import('src/pages/Application/Setup');

    return { Component };
  },
};

export const applicationEditRoutes: RouteObject = {
  path: `applications/:appId/${ApplicationRoutesEnum.Edit}`,
  lazy: async () => {
    const { default: Component } = await import('src/pages/Application/Edit');

    return { Component };
  },
};

export const applicationMembersRoutes: RouteObject = {
  path: `applications/:appId/${ApplicationRoutesEnum.Members}`,
  lazy: async () => {
    const { default: Component } = await import('src/pages/Application/Members');

    return { Component };
  },
};

export const applicationTasksRoutes: RouteObject = {
  path: `applications/:appId/${ApplicationRoutesEnum.Tasks}`,
  lazy: async () => {
    const { default: Component } = await import('src/pages/Application/Tasks');

    return { Component };
  },
};

export const applicationLinkNewRoutes: RouteObject = {
  path: `applications/:appId/${ApplicationRoutesEnum.LinkNew}`,
  lazy: async () => {
    const { default: Component } = await import('src/pages/Application/LinkNew');

    return { Component };
  },
};
